// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "worklog-worker" + "." + "65bee322e258b964add9" + ".js";
};